import { useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
import { Calendar2 } from "iconsax-reactjs";

const presets = [
    { label: "Last 7 days", range: [dayjs().subtract(7, "day"), dayjs()] },
    { label: "Last 30 days", range: [dayjs().subtract(30, "day"), dayjs()] },
    { label: "Last 6 months", range: [dayjs().subtract(6, "month"), dayjs()] },
    { label: "Last 1 year", range: [dayjs().subtract(1, "year"), dayjs()] },
];

const DateRangeSelector = ({ onChange }) => {
    const [selectedPreset, setSelectedPreset] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const startRef = useRef(null);
    const endRef = useRef(null);

    useEffect(() => {
        if (startDate && endDate) {
            onChange({ startDate, endDate });
        }
    }, [startDate, endDate]);

    const handlePresetClick = (preset) => {
        const start = preset.range[0].format("YYYY-MM-DD");
        const end = preset.range[1].format("YYYY-MM-DD");
        setStartDate(start);
        setEndDate(end);
        setSelectedPreset(preset.label);
    };

    const handleManualDateChange = (type, value) => {
        if (type === "start") setStartDate(value);
        if (type === "end") setEndDate(value);
        setSelectedPreset(null);
    };

    return (
        <div>
            <label className="text-sm font-medium text-[#161827] mb-2 block">
                Select date range
            </label>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
                {presets.map((preset) => (
                    <button
                        key={preset.label}
                        onClick={() => handlePresetClick(preset)}
                        className={`text-[14px] px-3 py-1.5 rounded-full font-[350] transition-colors duration-200 ${
                            selectedPreset === preset.label
                                ? "bg-[#E7DFFF] text-[#6F00FF]"
                                : "bg-[#F6F7FD] text-[#4F5372]"
                        }`}
                    >
                        {preset.label}
                    </button>
                ))}
            </div>

            <div className="grid grid-cols-2 gap-4">
                {/* Start Date */}
                <div
                    className="relative cursor-pointer"
                    onClick={() => startRef.current?.showPicker()}
                >
                    <input
                        ref={startRef}
                        type="date"
                        value={startDate}
                        onChange={(e) => handleManualDateChange("start", e.target.value)}
                        className="w-full text-base rounded-lg px-3 py-3 text-[#101828] bg-[#EFF0FA] appearance-none custom-hide-calendar"
                    />
                    <Calendar2
                        size="20"
                        color="#6F6B7B"
                        variant="Outline"
                        className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                    />
                </div>

                {/* End Date */}
                <div
                    className="relative cursor-pointer"
                    onClick={() => endRef.current?.showPicker()}
                >
                    <input
                        ref={endRef}
                        type="date"
                        value={endDate}
                        onChange={(e) => handleManualDateChange("end", e.target.value)}
                        className="w-full text-base rounded-lg px-3 py-3 text-[#101828] bg-[#EFF0FA] appearance-none custom-hide-calendar"
                    />
                    <Calendar2
                        size="20"
                        color="#6F6B7B"
                        variant="Outline"
                        className="absolute right-3 top-1/2 z-20 -translate-y-1/2 pointer-events-none"
                    />
                </div>
            </div>
        </div>
    );
};

export default DateRangeSelector;
